import common = require("../../../common");
import { IHotEditableFieldComponent } from '../../../common';
import HotEditableFormAction = require("./HotEditableFormAction");
import utilities = require("../../utilities");
import HotEditableButtonComponent = require("./HotEditableButtonComponent");
import HotEditableMessageComponent = require("./HotEditableMessageComponent");
import SharedEmbeddedParentForm = require("./SharedEmbeddedParentForm");
import Vue from "vue";
import HotEditableHiddenFieldComponent = require("./HotEditableHiddenFieldComponent");
import HotEditableSelectComponent = require("./HotEditableSelectComponent");
import HotEditableAddressComponent = require("./HotEditableAddressComponent");
import context = require("../../context");
import HotEditableTextboxComponent = require("./HotEditableTextboxComponent");
// import { component } from "vue/types/umd";
interface ISettings {
    loadFormModeFromUrl?: boolean;
    embeddedContentModels?: common.IEmbeddedContentModel[];
}
interface IHotEditableFormModeFieldConfig {
    name: string;
    value: any;
    editModeOn: boolean;
    canChangeEditMode: boolean;
}

interface IHotEditableFormModeButtonConfig {
    name: string;
    isHidden: boolean;
}

interface IFocusStruc {
    isButton: boolean,
    component: HotEditableButtonComponent | common.IHotEditableFieldComponent
}

interface IAlternativeMessage {
    updatedMessage: string;
    updatedMessageType: common.HotEditableMessageTypes;
}

interface IEmbeddedComponentToUpdate {
    isCurrent: boolean;
    url: string;
    name?: string;
    editModeOn?: boolean;
}

interface IUpdateFieldReturn {
    field: IHotEditableFieldComponent;
    isUpdated: boolean;
}
class HotEditableFormManager {
    static readonly formTypeQuerystringParam = "hotform";
    static readonly rootAttribute = "hot-editable";

    private _sharedEmbeddedParentForm = null as SharedEmbeddedParentForm;
    private _formName: string;
    private _fieldComponents = [] as common.IHotEditableFieldComponent[];
    private _buttonComponents = [] as HotEditableButtonComponent[];
    private _messageComponents = [] as HotEditableMessageComponent[];
    private _hotEdibaleFormModeFieldConfigRegistry = [] as IHotEditableFormModeFieldConfig[];
    private _hotEdibaleFormModeButtonConfigRegistry = [] as IHotEditableFormModeButtonConfig[];
    private _parent: common.IHotEditableFormParentVue;
    private _loadFormModeFromUrl = true;
    private _embeddedContentModels: common.IEmbeddedContentModel[];
    private _isEditionAlwaysOn = false;

    private _focusPreviousCallback: () => void;
    private _focusNextCallback: () => void;

    constructor(parent: common.IHotEditableFormParentVue, formName?: string, settings?: ISettings) {
        settings = settings || {} as ISettings;

        this._parent = parent || (() => { throw "L'argument 'parent' est NULL."; })();
        this._formName = formName || null;

        // settings
        this._loadFormModeFromUrl = settings.loadFormModeFromUrl !== false;//<- default is TRUE. 
        this._embeddedContentModels = settings.embeddedContentModels || [];

        if (this._parent)
            (this._parent as any as Vue).$nextTick(() => {
                this.refreshForceUpdate();
            });
    }

    destroyComponents() {

        const f = (components: any) => {
            for (let i = 0; i < (components || []).length; i++) {
                (components[i] as Vue).$destroy();
                components[i] = null;
            }
        };

        f(this._messageComponents);
        f(this._fieldComponents);
        f(this._buttonComponents);

        this._messageComponents = [];
        this._fieldComponents = [];
        this._buttonComponents = [];

        return this;
    }
    hasEmbeddedContents() { return !!(this._embeddedContentModels || []).length; }
    hasEmbeddedContent(componentName: string) {
        if (componentName)
            for (let i = 0; i < (this._embeddedContentModels || []).length; i++)
                if (this._embeddedContentModels[i].elementName === componentName)
                    return true;
        return false;
    }
    getFormName() { return this._formName; }
    setSharedEmbeddedParentForm(shared: SharedEmbeddedParentForm) {
        shared.addChild(this);
        this._sharedEmbeddedParentForm = shared;
        return this;
    }
    getSharedEmbeddedParentForm() {
        return this._sharedEmbeddedParentForm;
    }
    isHotEmbeddedComponent() {
        return !!this.getSharedEmbeddedParentForm();
    }
    setFocusCallbacksFromField(previous: () => void, next: () => void) {
        this._focusPreviousCallback = previous;
        this._focusNextCallback = next;
        return this;
    }

    /** focusFirstFieldOnEdition: default=TRUE */
    setupForm(isEditionAlwaysOn?: boolean, focusFirstFieldOnEdition?: boolean) {
        this._isEditionAlwaysOn = isEditionAlwaysOn === true;

        if (this.anyFieldCanChangeEditModeAtTrue() && this.anyFieldHasEditModeAtOff())
            if (this._parent.isVisibleToggleButton === true || this._parent.isVisibleToggleButton === false)
                this._parent.isVisibleToggleButton = true;

        const formModeFromCurrentUrl = this.setupFormModeFromCurrentUrl(focusFirstFieldOnEdition);
        if (formModeFromCurrentUrl) {
            if (this.canFocusFirstFieldOnEdition(focusFirstFieldOnEdition) && formModeFromCurrentUrl === common.HotEditableFormModes.edition)
                this.focusFirstField();
            return this;
        }

        const nbFields = this.countFields(true);
        var nbCanChangeEditModeFields = 0;
        var nbEditionModeOnFields = 0;

        this.forEachFields(x => {
            if (x.editModeOn)
                nbEditionModeOnFields++;
            if (x.canChangeEditMode)
                nbCanChangeEditModeFields++;
        }, true);

        const isEditionFormMode = nbCanChangeEditModeFields === 0 &&
            (
                (nbFields === 1 && nbEditionModeOnFields === 1) ||
                (nbFields > 1 && nbEditionModeOnFields > 1)
            );

        if (isEditionFormMode)
            this.setAsEditionFormMode();
        else if (this.canFocusFirstFieldOnEdition(focusFirstFieldOnEdition) && this._parent.formMode === common.HotEditableFormModes.edition)
            this.focusFirstField();

        return this;
    }
    /** focusFirstFieldOnEdition: default=TRUE */
    setupFormModeFromCurrentUrl(focusFirstFieldOnEdition?: boolean) {

        var updated = null as common.HotEditableFormModes;
        var formModeFromQS: common.HotEditableFormModes;

        if (this._isEditionAlwaysOn) {
            formModeFromQS = common.HotEditableFormModes.edition;

            if (this._loadFormModeFromUrl)
                this.updateFormModeUrlParametter(formModeFromQS);
        } else if (this._loadFormModeFromUrl) {
            const url = utilities.currentUrl();
            formModeFromQS = this.getFormModeFromUrl(url);
        } else {
            formModeFromQS = common.HotEditableFormModes.original;
        }

        if (formModeFromQS === common.HotEditableFormModes.edition) {
            this.setAsEditionFormMode(focusFirstFieldOnEdition);
            updated = formModeFromQS;
        }

        return updated;
    }
    countFields(excludesHiddenFields?: boolean) {
        excludesHiddenFields = excludesHiddenFields === true;
        var cpt = 0;
        this.forEachFields(x => {
            if (!excludesHiddenFields || x.fieldType !== common.HotEditableFieldTypes.hiddenField)
                cpt++;
        });
        return cpt;
    }
    /** Rollback les changements pour les champs implementant la methode 'revertLastChanges()' */
    revertLastChanges() { return this.innerRevertLastChanges(false); }
    /** Rollback les changements pour les champs implementant la methode 'revertLastChanges()' */
    confirmationRejected() { return this.innerRevertLastChanges(true); }
    private innerRevertLastChanges(fromConfirmationRejected: boolean) {
        var updated = false;
        this.forEachFields(x => {
            if ((!fromConfirmationRejected || x.revertLastChangesOnConfirmationRejected) && x.revertLastChanges && x.revertLastChanges())
                updated = true;
        });
        return updated;
    }
    focusFirstField() {
        const firstField = this.forEachFields(x => {
            if (!x.disabled &&
                x.editModeOn &&
                x.fieldType !== common.HotEditableFieldTypes.checkbox &&
                //x.fieldType !== common.HotEditableFieldTypes.datePicker &&
                x.fieldType !== common.HotEditableFieldTypes.select &&
                x.fieldType !== common.HotEditableFieldTypes.doubleSelect &&
                x.fieldType !== common.HotEditableFieldTypes.documentUpload &&
                x.fieldType !== common.HotEditableFieldTypes.imageUpload)
                return x;
        }, true);

        if (firstField)
            firstField.focus();
    }

    autoCloseMessages() {
        this.turnOffHasErrorForAllFields();
        this.forEachMessages(x => {
            if (x.autoCloseOnFormAction)
                x.clearMessage();
        });
        return this;
    }

    turnOffHasErrorForAllFields() {
        this.forEachFields(x => {
            if (x.hasError === true || x.hasError === false)
                x.hasError = false;
        }, true);
        return this;
    }

    cancelAllFields() {
        this.forEachFields(x => {
            if (x.canChangeEditMode && x.editModeOn && x.cancel)
                x.cancel();
        }, true);
        return this;
    }

    clearField(fieldName: string) {
        return this.clearFields([fieldName]);
    }

    clearFields(fieldNames: string[]) {
        this.forEachFields(x => {
            if (x.clearable !== false && this.listContainsValue(fieldNames, x.elementName))//NOTE : 'clearable' peut etre NULL
                x.clear();
        });
        return this;
    }

    clearAllFields(excludedFieldNames?: string[], clearVisibleFieldsOnly?: boolean) {
        clearVisibleFieldsOnly = clearVisibleFieldsOnly === true;//defualt is FALSE
        this.forEachFields(x => {
            if (x.clearable !== false && (!clearVisibleFieldsOnly || !x.isHidden || !x.isHidden()) && !this.listContainsValue(excludedFieldNames, x.elementName))//NOTE : 'clearable' peut etre NULL
                x.clear();
        });
        return this;
    }

    private listContainsValue<T>(list: T[], value: T) {
        if (list)
            for (let i = 0; i < list.length; i++)
                if (list[i] === value)
                    return true;
        return false;
    }

    anyFieldCanChangeEditModeAtTrue() {
        var res = false;
        this.forEachFields(x => {
            if (x.canChangeEditMode)
                return (res = true);
        }, true);
        return res;
    }

    anyFieldHasEditModeAtOff() {
        var res = false;
        this.forEachFields(x => {
            if (x.editModeOn === false)
                return (res = true);
        }, true);
        return res;
    }

    onToggleFormModeClick(event?: Event) {
        const isEdition = this._parent.formMode === common.HotEditableFormModes.edition;

        if (!this._isEditionAlwaysOn && isEdition) {
            if (this.fieldsHasChanged())
                this.applyUpdate();
            else
                this.setAsHotEditableFormMode();
            return;
        }

        if (!isEdition)
            this.setAsEditionFormMode();
    }
    /** Les proprietes 'isButtonClick' et 'changedFieldName' sont exclusives. */
    applyUpdate(actionValue?: string, actionType?: common.HotEditableActionTypes, isButtonClick?: boolean, buttonClickContext?: common.IButtonClickContext, changedFieldName?: string, autoCloseMessages?: boolean) {

        if (this.canNotDoFormAction())
            return this;

        actionType = actionType || common.HotEditableActionTypes.update;
        isButtonClick = isButtonClick === true;//== default is FALSE
        autoCloseMessages = autoCloseMessages !== false;//== default is TRUE
        if (isButtonClick && changedFieldName)
            throw "Les proprietes 'isButtonClick' et 'changedFieldName' sont exclusives.";

        const action = new HotEditableFormAction(this._parent);

        if (isButtonClick) {
            const context = buttonClickContext ?? {};
            const button = context.name
                ? this.getButtonByName(context.name)
                : this.getFirstButtonByType(common.HotEditableButtonTypes.update);

            if (button)
                action.setClickedButton(button, context);
        }
        else if (changedFieldName) {
            const field = this.getFieldByName(changedFieldName);
            if (field)
                action.setChangedField(field);
        }

        if (autoCloseMessages)
            this.autoCloseMessages();

        this.doFormAction(action.setActionType(actionType).setActionValue(actionValue));

        return this;
    }

    updateFieldFromApi(fieldToUpdate: common.IHotEditableUpdateField, applyChanged?: boolean) {
        if (fieldToUpdate) 
            this.innerUpdateField(fieldToUpdate.name, fieldToUpdate.value, fieldToUpdate.valueOptions, fieldToUpdate.disabled, applyChanged);
        return this;
    }
    /** Retournera TRUE si le champ OU le bouton existe. 
     * 
     * Activation/desactivation des boutons : 'name'+'disabled' */
    updateField(name: string, value: string, valueOptions?: string, disabled?: boolean, applyChanged?: boolean, closeMessage?: boolean) {
        return this.innerUpdateField(name, value, valueOptions, disabled, applyChanged, closeMessage).isUpdated;
    }

    private innerUpdateField(name: string, value: string, valueOptions?: string, disabled?: boolean, applyChanged?: boolean, closeMessage?: boolean) {
        applyChanged = applyChanged === true;//default is FALSE
        closeMessage = closeMessage !== false;//default is TRUE

        const f = this.getFieldByName(name);
        const r = {
            field: f,
            isUpdated: false
        } as IUpdateFieldReturn;

        if (!f) {
            const b = this.getButtonByName(name);
            if (b) {
                if (disabled === true || disabled === false)
                    b.disabled = disabled;

                r.isUpdated = true;
                return r;
            }

            return r;
        }

        if (valueOptions || valueOptions === '')
            this.updateFieldValueOptions(f, valueOptions);
        if (value || value === '')
            f.setFromTextualValue(value);
        if (disabled === true || disabled === false)
            f.disabled = disabled;
        if (applyChanged)
            if (f.changed)
                f.changed();

        const m = this.getMessageComponentByFieldName(name);
        if (m)
            m.clearMessage();

        if (f.fieldType === common.HotEditableFieldTypes.address)
            (f as HotEditableAddressComponent).formManager.autoCloseMessages();

        r.isUpdated = true;
        return r;
    }
    private updateFieldValueOptions(field: IHotEditableFieldComponent, valueOptions: string) {
        if (!field) throw "L'argument 'field' est NULL.";
        valueOptions = valueOptions || '';
        if (field.fieldType === common.HotEditableFieldTypes.select)
            (field as HotEditableSelectComponent).setOptionsFromTextualValue(valueOptions);
        else throw "La mise a jour des 'valueOptions' n'est pas supporté dans les champs de type '" + field.fieldType + "'.";
    }
    /** Retournera TRUE si le champ existe et a ete mis a jour */
    disabledField(name: string, value?: boolean) {
        value = value !== false;
        const f = this.getFieldByName(name);
        if (f) {
            f.disabled = value;
            return true;
        }
        const b = this.getButtonByName(name);
        if (b) {
            b.disabled = value;
            return true;
        }
        return false;
    }
    private canFocusFirstFieldOnEdition(x?: boolean) {
        return (x === true || x === false) ? x : !this.isHotEmbeddedComponent();
    }
    /** Mode: Edition (standard form), focusFirstFieldOnEdition: default=TRUE */
    setAsEditionFormMode(focusFirstFieldOnEdition?: boolean) {

        const f = () => {

            if (this._parent.formMode === common.HotEditableFormModes.edition)
                return;

            this._parent.formMode = common.HotEditableFormModes.edition;

            this.forEachFields(x => {
                if (x.canChangeEditMode) {
                    this.registerOriginalFieldConfig(x);
                    if (x.changeMode)
                        x.changeMode(false, true);
                }
            });

            // Gestion automatique des boutons :
            // la methode "manageButtonsOnFormModeChange" (optionelle) DOIT etre NON-implementee OU retourner TRUE
            if (!this._parent.manageButtonsOnFormModeChange || this._parent.manageButtonsOnFormModeChange())
                this.forEachButtons(x => {
                    this.registerOriginalButtonConfig(x);
                    if (x.buttonType === common.HotEditableButtonTypes.update || x.buttonType === common.HotEditableButtonTypes.cancel)
                        x.show();
                    else if (x.buttonType === common.HotEditableButtonTypes.back)
                        x.hide();
                });

            this.updateFormModeUrlParametter(common.HotEditableFormModes.edition);

            if (this.canFocusFirstFieldOnEdition(focusFirstFieldOnEdition))
                this.focusFirstField();
        };

        // Doit attendre que tout les events dse controls aient envoye leur action de changement intervenant parfois apres un $nextTick
        setTimeout(() => { f(); }, 375);

        return this;
    }

    /** Mode: HotEditable (Ajax live) */
    setAsHotEditableFormMode() {
        this._parent.formMode = common.HotEditableFormModes.original;

        this.forEachFields(x => {
            const c = this.retrieveOriginalFieldConfig(x);
            if (!c)
                return;
            if (x.changeMode)
                x.changeMode(c.canChangeEditMode, c.editModeOn);
        });

        this.forEachButtons(x => {
            const c = this.retrieveOriginalButtonConfig(x);
            if (!c)
                return;
            x.hide(c.isHidden);
        });

        this.updateFormModeUrlParametter(common.HotEditableFormModes.original);

        return this;
    }

    focusNextComponentFromField(field: IHotEditableFieldComponent) {
        const x = this.getNextComponentFromField(field);
        if (x) {
            this.updateComponentsFocus(x);
            return true;
        }

        if (this._focusNextCallback)
            this._focusNextCallback();

        return false;
    }

    focusNextComponentFromButton(button: HotEditableButtonComponent) {
        const x = this.getNextComponentFromButton(button);
        if (x) {
            this.updateComponentsFocus(x);
            return true;
        }

        return false;
    }

    focusPreviousComponentFromField(field: IHotEditableFieldComponent) {
        const x = this.getPreviousComponentFromField(field);
        if (x) {
            this.updateComponentsFocus(x, true);
            return true;
        }

        if (this._focusPreviousCallback)
            this._focusPreviousCallback();

        return false;
    }

    focusPreviousComponentFromButton(button: HotEditableButtonComponent) {
        const x = this.getPreviousComponentFromButton(button);
        if (x) {
            this.updateComponentsFocus(x, true);
            return true;
        }
        return false;
    }
    getMessageComponentByFieldName(refFieldName: string) {
        const r = this.getMessageComponentsByFieldNames([refFieldName]);
        return r.length ? r[0] : null;
    }
    getMessageComponentsByFieldNames(refFieldNames: string[]) {
        if (!refFieldNames)
            throw "L'argument 'refFieldName' est requis.";

        const m = [] as HotEditableMessageComponent[];

        if (!refFieldNames.length)
            return m;

        this.forEachMessages(x => {
            for (let i = 0; i < refFieldNames.length; i++) {
                const r = refFieldNames[i];
                if (x.fieldName === r)
                    m.push(x)
            }
        });

        this.forEachFields(x => {
            const innerFormManager = (x as any).formManager as HotEditableFormManager;
            if (innerFormManager) {
                const innerMessages = innerFormManager.getMessageComponentsByFieldNames(refFieldNames);
                if (innerMessages)
                    for (let i = 0; i < innerMessages.length; i++)
                        m.push(innerMessages[i]);
            }
        }, true);

        return m;
    }
    getMessageComponentByName(name: string) {
        if (!name)
            throw "L'argument 'refFieldName' est requis.";

        var m = this.forEachMessages(x => {
            if (x.elementName === name)
                return x;
        });

        return (m || null) as HotEditableMessageComponent;
    }
    getMessageComponents() {
        return this._messageComponents || [];
    }

    getButtonByName(name: string) {

        const b = this.forEachButtons(x => {
            return x.elementName === name ? x : null;
        });
        return (b || null) as HotEditableButtonComponent;
    }

    getFirstButtonByType(buttonType: common.HotEditableButtonTypes) {

        if (!buttonType)
            return null;

        const b = this.forEachButtons(x => {
            return x.buttonType === buttonType ? x : null;
        });

        return (b || null) as HotEditableButtonComponent;
    }

    getButtons(buttonType?: common.HotEditableButtonTypes) {
        if (!buttonType)
            return this._buttonComponents;

        const r = [] as HotEditableButtonComponent[];
        this.forEachButtons(x => {
            if (x.buttonType === buttonType)
                r.push(x);
        });
        return r;
    }

    getFields() {
        return this._fieldComponents;
    }

    getFieldsByNames(names: string[]) {
        if (!names || !names.length)
            return null as common.IHotEditableFieldComponent[];

        const fields = [] as common.IHotEditableFieldComponent[];

        this.forEachFields(x => {
            for (let i = 0; i < names.length; i++) {
                const n = names[i];
                if (x.elementName === n)
                    fields.push(x);
            }
            const innerFormManager = (x as any).formManager as HotEditableFormManager;
            if (innerFormManager) {
                const innerFields = innerFormManager.getFieldsByNames(names);
                if (innerFields.length)
                    for (let i = 0; i < innerFields.length; i++)
                        fields.push(innerFields[i]);
            }
        });
        return fields;
    }
    getFieldByName(name: string) {
        if (!name)
            return null;

        const f = this.forEachFields(x => {
            if (x.elementName === name)
                return x;
            const innerFormManager = (x as any).formManager as HotEditableFormManager;
            if (innerFormManager) {
                const innerField = innerFormManager.getFieldByName(name);
                if (innerField)
                    return innerField;
            }
            return null;
        });
        return (f || null) as common.IHotEditableFieldComponent;
    }
    getFieldValueByName(name: string) {
        const f = this.getFieldByName(name);
        return f ? f.elementValue : null
    }
    /** Retournera TRUE/FALSE si le champ existe, sinon retournera NULL. */
    fieldIsEditModeOn(fieldName: string) {
        if (!fieldName)
            return;
        const f = this.getFieldByName(fieldName);
        return f ? f.editModeOn === true : null;
    }
    getSelectCodeByName(name: string) {
        const value = this.getFieldValueByName(name);
        return value ? value.code : null;
    }
    hasMessageByName(name: string) {
        const m = this.getMessageComponentByName(name);
        return m && !!m.message;
    }
    getCheckboxes() {
        const r = [] as IHotEditableFieldComponent[];
        this.forEachFields(x => {
            if (x.fieldType === common.HotEditableFieldTypes.checkbox)
                r.push(x as IHotEditableFieldComponent);
        }, true);
        return r;
    }

    getTextboxes() {
        const r = [] as IHotEditableFieldComponent[];
        this.forEachFields(x => {
            if (x.fieldType === common.HotEditableFieldTypes.checkbox)
                r.push(x as IHotEditableFieldComponent);
        }, true);
        return r;
    }

    getSelects() {
        const r = [] as IHotEditableFieldComponent[];
        this.forEachFields(x => {
            if (x.fieldType === common.HotEditableFieldTypes.checkbox)
                r.push(x as IHotEditableFieldComponent);
        }, true);
        return r;
    }

    // getTinymces() {
    //     const r = [] as IHotEditableFieldComponent[];
    //     this.forEachFields(x => {
    //         if (x.fieldType === common.HotEditableFieldTypes.checkbox)
    //             r.push(x as IHotEditableFieldComponent);
    //     });
    //     return r;
    // }

    getDatePickers() {
        const r = [] as IHotEditableFieldComponent[];
        this.forEachFields(x => {
            if (x.fieldType === common.HotEditableFieldTypes.checkbox)
                r.push(x as IHotEditableFieldComponent);
        }, true);
        return r;
    }

    registerField(field: IHotEditableFieldComponent) {
        this._fieldComponents.push(field);
        return this;
    }

    registerButton(button: HotEditableButtonComponent) {
        this._buttonComponents.push(button);
        return this;
    }

    registerMessage(message: HotEditableMessageComponent) {
        this._messageComponents.push(message);
        return this;
    }

    editModeChanged(field: IHotEditableFieldComponent) {
        if ((this._parent as any).setEditModeActivatedProperty)
            (this._parent as any).setEditModeActivatedProperty(field.idElement, field.editModeOn && field.canChangeEditMode);
        return this;
    }
    fieldChanged(field: IHotEditableFieldComponent, errors?: common.IError[]) {
        if (this.canNotDoFormAction())
            return this;

        const action = new HotEditableFormAction(this._parent);

        action
            .setChangedField(field)
            .addErrors(errors);

        this.triggerFormAction(action);

        return this;
    }

    buttonClick(button: HotEditableButtonComponent, context: common.IButtonClickContext) {
        if (this.canNotDoFormAction())
            return this;

        const action = new HotEditableFormAction(this._parent);

        action.setClickedButton(button, context);

        this.triggerFormAction(action);

        return this;
    }

    /** L'argument 'name' est a la fois RefFieldNames et MessageNames. Retournera TRUE si un MessageComponent (form) a ete mis a jour. */
    displayMessage(name: string, message?: string, messageType?: common.MessageTypes) {
        if (!name)
            return false;
        return this.displayMessages([{ name: name } as common.IFormFieldReferenceConfiguration], message, utilities.convertMessageTypeToHotEditableMessageType(messageType));
    }

    /** L'argument 'name' est a la fois RefFieldNames et MessageNames */
    private displayMessages(configurations: common.IFormFieldReferenceConfiguration[], message?: string, messageType?: common.HotEditableMessageTypes) {
        configurations = configurations || [];
        const names = [] as string[];
        for (let i = 0; i < configurations.length; i++) {
            const c = configurations[i];
            if (c && c.name && !c.hideMessage)
                names.push(c.name);
        }
        const messageComponents = this.getMessageComponentsByFieldNames(names);

        if (names.length) {
            const messageName = names[0];
            const message = this.getMessageComponentByName(messageName);
            if (message)
                messageComponents.push(message);
        }

        for (let i = 0; i < messageComponents.length; i++)
            messageComponents[i].update(message, messageType);

        const isUpdated = !!messageComponents.length;

        return isUpdated;
    }

    displayFieldError(formName?: string, error?: common.IError, focusFirstErrorField?: boolean) {
        if (!formName || !error || !error.formFieldReferences)
            return false;

        var matchRef = null as common.IFormFieldReference;
        for (let i = 0; i < error.formFieldReferences.length; i++) {
            const r = error.formFieldReferences[i];

            if (r.formName === formName) {
                matchRef = r;
                break;
            }
        }

        if (!matchRef || !matchRef.fieldConfigurations || !matchRef.fieldConfigurations.length)
            return false;

        const alt = this.extractAltMessageFromMacro(error.message, common.HotEditableMessageTypes.error);

        setTimeout(() => {
            this.displayMessages(matchRef.fieldConfigurations, alt.updatedMessage, alt.updatedMessageType);
        }, 250);

        const names = [] as string[];
        for (let i = 0; i < matchRef.fieldConfigurations.length; i++) {
            const c = matchRef.fieldConfigurations[i];
            if (c && c.name)
                names.push(c.name);
        }
        const fields = this.getFieldsByNames(names);
        if (fields)
            for (let i = 0; i < fields.length; i++) {
                const f = fields[i];

                if (f.hasError === true || f.hasError === false)
                    f.hasError = true;

                const parent = (f as any as Vue).$parent as any as common.IHotEditableFieldComponent;
                const parentIsField = parent.isParent === true;
                if (parentIsField && parent.editModeOn === false) {
                    parent.editModeOn = true;
                    const parentFormManager = (parent as any)._formManagerParent as HotEditableFormManager;
                    if (parentFormManager)
                        parentFormManager.forEachFields(x => {
                            if (x.elementName !== parent.elementName && x.canChangeEditMode && x.editModeOn)
                                x.editModeOn = false;
                        }, true);
                }

                if (focusFirstErrorField && f.editModeOn) {

                    const isFocusable =
                        f.fieldType === common.HotEditableFieldTypes.address ||
                        f.fieldType === common.HotEditableFieldTypes.textbox ||
                        f.fieldType === common.HotEditableFieldTypes.tinymce;

                    if (isFocusable && f.focus)
                        f.focus();
                }
            }
        return true;
    }

    /** Retournera TRUE si le message du champ existe. */
    displayFieldErrors(formName?: string, errors?: common.IError[], focusFirstErrorField?: boolean) {
        focusFirstErrorField = focusFirstErrorField === true;// default is FALSE
        errors = errors || [];

        var isDisplayed = false;
        for (let i = 0; i < errors.length; i++)
            if (this.displayFieldError(formName, errors[i], focusFirstErrorField)) {
                isDisplayed = true;
                focusFirstErrorField = false;
            }

        return isDisplayed;
    }

    /** petit helper pour travailler avec le form2 (css) */
    buildFieldContainerCssClasses(state: boolean) {
        const classes = {
            'inline-edition-on': state,
            'inline-edition-off': !state
        };

        return classes;
    }


    triggerFormError(errors: common.IError[], config?: common.IHotEditableFormConfig) {
        this.doFormError(errors, config);
    }
    private canNotDoFormAction() {
        return !this._parent.shared.onFormAction;
    }
    private canNotDoFormError() {
        return !this._parent.shared.onFormError;
    }
    private doFormAction(action: HotEditableFormAction) {
        this.refreshForceUpdate();
        if (this.canNotDoFormAction())
            return;
        this._parent.shared.onFormAction(action);
    }
    private doFormError(errors: common.IError[], config?: common.IHotEditableFormConfig) {
        this.refreshForceUpdate();
        if (this.canNotDoFormError())
            return;
        this._parent.shared.onFormError(errors, config);
    }
    private refreshForceUpdate() {
        if (this._parent && this._parent.refreshForceUpdate)
            this._parent.refreshForceUpdate();
    }
    private extractAltMessageFromMacro(message: string, defaultMessageType: common.HotEditableMessageTypes) {
        const r = utilities.extractAltMessageFromMacro(message, null, defaultMessageType);
        return {
            updatedMessage: r.updatedMessage,
            updatedMessageType: common.HotEditableMessageTypes[r.updatedMessageType]
        } as IAlternativeMessage;
    }

    private triggerFormAction(a: HotEditableFormAction) {
        this.autoCloseMessages();
        if (this.canNotDoFormAction())
            return;
        this.doFormAction(a);
    }

    private updateFormModeUrlParametter(mode?: common.HotEditableFormModes) {
        mode = mode || common.HotEditableFormModes.original;
        const currentUrl = utilities.currentUrl() || '';
        const parts = currentUrl.split('?');
        if (!parts.length)
            return;
        const firstPart = parts[0];
        const secondPart = parts.length == 1 ? '' : parts[1];
        var newQueryString = '';
        var hotFormParamUpdated = false;
        if (secondPart) {
            const paramsParts = secondPart.split('&');

            for (let i = 0; i < paramsParts.length; i++) {
                const paramParts = (paramsParts[i] || '').split('=');
                const param = paramParts.length < 1 ? '' : (paramParts[0] || '');
                var value = paramParts.length < 2 ? '' : (paramParts[1] || '');

                if (param.toLowerCase() === HotEditableFormManager.formTypeQuerystringParam) {
                    value = mode;
                    hotFormParamUpdated = true;
                }

                if (newQueryString)
                    newQueryString += '&';

                newQueryString += param + '=' + value;
            }
        }

        if (!hotFormParamUpdated) {
            if (newQueryString)
                newQueryString += '&';
            newQueryString += HotEditableFormManager.formTypeQuerystringParam + '=' + mode;
        }

        const newUrl = firstPart + '?' + newQueryString;
        utilities.updateBrowserUrl(newUrl);
    }

    private getFormModeFromUrl(url: string) {
        const qs = utilities.extractQueryString(url);
        var mode = common.HotEditableFormModes.original;
        if (qs)
            for (let k in qs) {
                if (k.toLowerCase() === HotEditableFormManager.formTypeQuerystringParam) {
                    const v = (qs[k] as string || '').toLowerCase();
                    if (v === common.HotEditableFormModes.edition)
                        mode = common.HotEditableFormModes.edition;
                    // else if (v === common.HotEditableFormModes.togglable)
                    //     mode = common.HotEditableFormModes.togglable;
                    else
                        mode = common.HotEditableFormModes.original;
                    break;
                }
            }
        return mode;
    }

    private registerOriginalFieldConfig(field: IHotEditableFieldComponent) {
        const registry = this.retrieveOriginalFieldConfig(field);
        const value = field.copyElementValue ? field.copyElementValue() : field.elementValue;
        if (registry) {
            registry.value = value;
            return;
        }

        this._hotEdibaleFormModeFieldConfigRegistry.push({
            value: value,
            name: field.elementName,
            editModeOn: field.editModeOn,
            canChangeEditMode: field.canChangeEditMode
        });
    }

    private registerOriginalButtonConfig(button: HotEditableButtonComponent) {
        const registry = this.retrieveOriginalButtonConfig(button);
        if (registry)
            return;

        this._hotEdibaleFormModeButtonConfigRegistry.push({
            name: button.elementName,
            isHidden: button.isHidden
        });
    }

    private retrieveOriginalFieldConfig(field: IHotEditableFieldComponent) {
        if (!field || !field.elementName)
            return null as IHotEditableFormModeFieldConfig;

        for (let i = 0; i < this._hotEdibaleFormModeFieldConfigRegistry.length; i++) {
            const x = this._hotEdibaleFormModeFieldConfigRegistry[i];
            if (x.name === field.elementName)
                return x;
        }

        return null as IHotEditableFormModeFieldConfig;
    }

    private retrieveOriginalButtonConfig(button: HotEditableButtonComponent) {
        if (!button || !button.elementName)
            return null as IHotEditableFormModeButtonConfig;

        for (let i = 0; i < this._hotEdibaleFormModeButtonConfigRegistry.length; i++) {
            const x = this._hotEdibaleFormModeButtonConfigRegistry[i];
            if (x.name === button.elementName)
                return x;
        }

        return null as IHotEditableFormModeButtonConfig;
    }

    private fieldsHasChanged() {
        const r = this.forEachFields(x => {
            const c = this.retrieveOriginalFieldConfig(x);
            if (c) {
                if (x.isSameElementValue) {
                    if (!x.isSameElementValue(x.elementValue, c.value))
                        return true;
                }
                else if (c.value !== x.elementValue) {
                    return true;
                }
            }
        });

        return r === true;
    }

    private updateComponentsFocus(focusStruc?: IFocusStruc, fromPrevious?: boolean) {

        if (!focusStruc)
            return;

        if (focusStruc.isButton) {
            if (focusStruc.component.focus)
                focusStruc.component.focus();
        } else {
            const c = focusStruc.component as IHotEditableFieldComponent;
            if (c.canChangeEditMode) {
                if (c.editClick)
                    c.editClick(null, true, fromPrevious);
            } else if (c.focus) {
                c.focus(fromPrevious);
            }
        }
    }

    private getNextComponentFromField(field: IHotEditableFieldComponent) {
        if (!field)
            throw "[HotEditableFormManager::getNextComponentFromField] Le champ est NULL.";

        return this.getNextOrPreviousComponentTablableComponentFromIndex(field.tabIndex);
    }

    private getNextComponentFromButton(button: HotEditableButtonComponent) {
        if (!button)
            throw "[HotEditableFormManager::getNextComponentFromButton] Le bouton est NULL.";

        return this.getNextOrPreviousComponentTablableComponentFromIndex(button.tabIndex);
    }

    private getPreviousComponentFromField(field: IHotEditableFieldComponent) {
        if (!field)
            throw "[HotEditableFormManager::getPreviousComponentFromField] Le champ est NULL.";

        return this.getNextOrPreviousComponentTablableComponentFromIndex(field.tabIndex, true);
    }

    private getPreviousComponentFromButton(button: HotEditableButtonComponent) {
        if (!button)
            throw "[HotEditableFormManager::getPreviousComponentFromButton] Le bouton est NULL.";

        return this.getNextOrPreviousComponentTablableComponentFromIndex(button.tabIndex, true);
    }

    private getNextOrPreviousComponentTablableComponentFromIndex(currentIndex?: number, getPrevious?: boolean) {
        currentIndex = currentIndex || 0;
        getPrevious = getPrevious === true;

        var sorted = [];

        const append = (i: number, x: any, isButton?: boolean) => {
            if (i || i === 0)
                sorted.push({ index: i, c: x, isButton: isButton === true });
        };

        const build = (c: any, b: boolean) => {
            return { component: c, isButton: b } as IFocusStruc;
        }

        this.forEachFields(x => {
            if (!x.disabled && (x.canChangeEditMode || x.editModeOn))
                append(x.tabIndex, x);
        }, true);

        this.forEachButtons(x => {
            if (!x.isHidden)
                append(x.tabIndex, x, true);
        });

        sorted = sorted.sort((a: any, b: any) => {
            return a.index > b.index ? 1 : -1;
        });

        if (getPrevious)
            for (let i = sorted.length - 1; i >= 0; i--) {
                const x = sorted[i];
                if (x.index < currentIndex)
                    return build(x.c, x.isButton);
            }
        else //is next
            for (let i = 0; i < sorted.length; i++) {
                const x = sorted[i];
                if (x.index > currentIndex)
                    return build(x.c, x.isButton);
            }

        return null as IFocusStruc;
    }

    /** loop sur les items. Retourner un objet pour faire un Break et obtenir l'objet retourne */
    private forEachMessages(action: (m: HotEditableMessageComponent) => any) {
        if (action)
            for (let i = 0; i < this._messageComponents.length; i++) {
                const x = this._messageComponents[i];
                const r = action(x);
                if (r || r === 0 || r === '')
                    return r;
            }

        return null;
    }

    /** loop sur les items. Retourner un objet pour faire un Break et obtenir l'objet retourne */
    private forEachFields(action: (f: IHotEditableFieldComponent) => any, excludesHiddenFields?: boolean) {
        excludesHiddenFields = excludesHiddenFields === true;
        if (action)
            for (let i = 0; i < this._fieldComponents.length; i++) {
                const x = this._fieldComponents[i];
                if (excludesHiddenFields && x.fieldType === common.HotEditableFieldTypes.hiddenField)
                    continue;
                const r = action(x);
                if (r || r === 0 || r === '')
                    return r;
            }

        return null;
    }

    /** loop sur les items. Retourner un objet pour faire un Break et obtenir l'objet retourne */
    private forEachButtons(action: (b: HotEditableButtonComponent) => any) {
        if (action)
            for (let i = 0; i < this._buttonComponents.length; i++) {
                const x = this._buttonComponents[i];
                const r = action(x);
                if (r || r === 0 || r === '')
                    return r;
            }

        return null;
    }

    // SUM CHECK =================================================================================================

    _innerUpdateConcurrencySumCheck(sumCheck: string) {
        if (!sumCheck && sumCheck !== '')
            return false;
        const f = this.getFieldByName("ConcurrencySumCheck") as HotEditableHiddenFieldComponent;
        if (!f)
            throw "Le champ correspondant au nom 'ConcurrencySumCheck' n'existe pas.";
        f.setFromTextualValue(sumCheck);
        return !!f;
    }

    // EMBEDDED CONTENTS ==========================================================================================
    getCurrentEmbeddedComponentName() { return this._sharedEmbeddedParentForm ? this._sharedEmbeddedParentForm.getEmbeddedComponentName() : null; }
    /** Si 'clause' est NULL, alors TOUT les models seront retournes, sinon, seul ceux dont la clause retourne TRUE seront retournes */
    getEmbeddedContentModels(clause?: (model: common.IEmbeddedContentModel) => boolean) {
        if (!clause)
            return this._embeddedContentModels;
        const r = [] as common.IEmbeddedContentModel[];
        for (let i = 0; i < this._embeddedContentModels.length; i++) {
            var m = this._embeddedContentModels[i];
            if (!m)
                continue;
            if (clause(m))
                r.push(m);
        }
        return r;
    }
    showEmbeddedContentModelsByCategory(category: string, isVisible?: boolean) {
        category = category || '';
        isVisible = isVisible !== false;//default is TRUE.

        for (let i = 0; i < this._embeddedContentModels.length; i++) {
            const f = this._embeddedContentModels[i];
            if ((!f.category && !category) || (f.category && category && f.category === category))
                f.isVisible = isVisible;
        }

        return this;
    }
    countEmbeddedContentModelsByCategory(category: string) {
        category = category || '';

        var cpt = 0;
        for (let i = 0; i < this._embeddedContentModels.length; i++) {
            const f = this._embeddedContentModels[i];
            if ((f.category || '') === category)
                cpt++;
        }

        return cpt;
    }
    showHotEmbeddedComponentsByCategory(category: string, isVisible?: boolean) {
        if (this._sharedEmbeddedParentForm)
            this._sharedEmbeddedParentForm.showHotEmbeddedComponentsByCategory(category, isVisible);
        else
            this._innerShowHotEmbeddedComponentsByCategory(category, isVisible);
        return this;
    }
    _innerShowHotEmbeddedComponentsByCategory(category: string, isVisible?: boolean) {
        category = category || '';
        isVisible = isVisible !== false;//default is TRUE.

        const fields = this.getHotEmbeddedComponents();
        for (let i = 0; i < fields.length; i++) {
            const f = fields[i];
            if ((!f.category && !category) || (f.category && category && f.category === category))
                f.isVisible = isVisible;
        }
    }
    countHotEmbeddedComponentsByCategory(category: string) {
        if (this._sharedEmbeddedParentForm)
            return this._sharedEmbeddedParentForm.countHotEmbeddedComponentsByCategory(category);
        return this._innerCountHotEmbeddedComponentsByCategory(category);
    }
    _innerCountHotEmbeddedComponentsByCategory(category: string) {
        category = category || '';

        const fields = this.getHotEmbeddedComponents();
        var cpt = 0;
        for (let i = 0; i < fields.length; i++) {
            const f = fields[i];
            if ((f.category || '') === category)
                cpt++;
        }

        return cpt;
    }
    /** Si 'nextUrl' est NULL, alors l'url sera celle definie par DEFAULT */
    updateCurrentHotEmbeddedComponent(nextUrl?: string, urlParameters?: {}, editModeOn?: boolean, finalEvalCallback?: () => void) {
        this._sharedEmbeddedParentForm._innerUpdateCurrentHotEmbeddedComponent(this._sharedEmbeddedParentForm.getEmbeddedComponentName(), nextUrl, urlParameters, editModeOn, finalEvalCallback);
        return this;
    }
    /** Si 'nextUrl' est NULL, alors l'url sera celle definie par DEFAULT */
    updateHotEmbeddedComponent(name?: string, nextUrl?: string, urlParameters?: {}, editModeOn?: boolean, finalEvalCallback?: () => void) {
        if (this._sharedEmbeddedParentForm)
            this._sharedEmbeddedParentForm._innerUpdateHotEmbeddedComponent(this._sharedEmbeddedParentForm.getEmbeddedComponentName(), name, nextUrl, urlParameters, editModeOn, finalEvalCallback);
        else
            this._innerUpdateHotEmbeddedComponent(this.getCurrentEmbeddedComponentName(), name, nextUrl, urlParameters, editModeOn, finalEvalCallback);
        return this;
    }
    private hasEmbeddedComponentParent(componentName: string) {
        if (!this._sharedEmbeddedParentForm)
            return false;
        if (this._sharedEmbeddedParentForm.getEmbeddedComponentName() === componentName)
            return true;
        return this._sharedEmbeddedParentForm.hasParent(componentName);
    }
    /** Retournera "alsoUpdateCurrent" (bool) */
    updateHotEmbeddedComponents(embeddedForms: common.IEmbeddedComponentToUpdate[], finalEvalCallback?: () => void) {

        // Garantir que le 'name' du current embedded component est NULL (necessaire pour le sorting ci-dessous)
        const currentEmbeddedComponentCallerName = this._sharedEmbeddedParentForm.getEmbeddedComponentName();
        for (let i = 0; i < embeddedForms.length; i++) {
            const x = embeddedForms[i];
            if (x.name === currentEmbeddedComponentCallerName)
                x.name = null;
        }

        //ATTENTION!! Traiter les autres widget avant celui-ci.
        const componentsToUpdate = embeddedForms.sort((a, b) => (a.name || '') < (b.name || '') ? 1 : -1);
        const queue = [] as IEmbeddedComponentToUpdate[];
        const callbacks = [] as (() => void)[];
        const getCallback = (i: number) => {
            return i || i === 0 ? callbacks[i] : null;
        };
        var alsoUpdateCurrent = false;
        for (let i = 0; i < componentsToUpdate.length; i++) {
            const c = componentsToUpdate[i];
            const isCurrent = !c.name;
            queue.push({
                name: c.name,
                url: c.url,
                isCurrent: isCurrent,
                editModeOn: c.editModeOn
            });
            callbacks.push(null);//prevoir une slot pour le callback
            if (alsoUpdateCurrent)
                continue;

            if (isCurrent || this.hasEmbeddedComponentParent(c.name))
                alsoUpdateCurrent = true;
        }

        for (let i = queue.length - 1; i >= 0; i--) {
            const x = queue[i];
            const nextCallbackIndex = i < queue.length - 1 ? i + 1 : null;
            callbacks[i] = x.isCurrent
                ? () => {
                    this._innerUpdateCurrentHotEmbeddedComponent(currentEmbeddedComponentCallerName, x.url, null, x.editModeOn, getCallback(nextCallbackIndex));
                }
                : () => {
                    this._innerUpdateHotEmbeddedComponentRouting(currentEmbeddedComponentCallerName, x.name, x.url, null, x.editModeOn, getCallback(nextCallbackIndex));
                };
        }

        if (callbacks.length)
            callbacks[0]();

        if (finalEvalCallback)
            finalEvalCallback();

        return alsoUpdateCurrent;
    }
    /** Si 'nextUrl' est NULL, alors l'url sera celle definie par DEFAULT */
    _innerUpdateCurrentHotEmbeddedComponent(currentEmbeddedComponentCallerName: string, nextUrl?: string, urlParameters?: {}, editModeOn?: boolean, finalEvalCallback?: () => void) {
        this._sharedEmbeddedParentForm._innerUpdateCurrentHotEmbeddedComponent(currentEmbeddedComponentCallerName, nextUrl, urlParameters, editModeOn, finalEvalCallback);
        return this;
    }
    /** Si 'nextUrl' est NULL, alors l'url sera celle definie par DEFAULT */
    _innerUpdateHotEmbeddedComponentRouting(currentEmbeddedComponentCallerName: string, name: string, nextUrl?: string, urlParameters?: {}, editModeOn?: boolean, finalEvalCallback?: () => void) {
        if (this._sharedEmbeddedParentForm)
            return this._sharedEmbeddedParentForm
                ._innerUpdateHotEmbeddedComponent(currentEmbeddedComponentCallerName, name, nextUrl, urlParameters, editModeOn, finalEvalCallback)
                .isParentOf(currentEmbeddedComponentCallerName);
        return this._innerUpdateHotEmbeddedComponent(currentEmbeddedComponentCallerName, name, nextUrl, urlParameters, editModeOn, finalEvalCallback);
    }
    /** Si 'nextUrl' est NULL, alors l'url sera celle definie par DEFAULT */
    _innerUpdateHotEmbeddedComponent(currentEmbeddedComponentCallerName: string, name?: string, nextUrl?: string, urlParameters?: {}, editModeOn?: boolean, finalEvalCallback?: () => void) {
        name = name || currentEmbeddedComponentCallerName;
        const c = this.getFieldByName(name) as common.IHotEditableEmbeddedComponent;
        if (!c) {
            if (finalEvalCallback)
                finalEvalCallback();
            return false;
        }
        c.update(nextUrl, urlParameters, editModeOn, finalEvalCallback);
        return true;
    }
    _innerRefreshHotEmbeddedComponent(name?: string, urlParameters?: {}, editModeOn?: boolean, finalEvalCallback?: () => void) {
        const c = this.getFieldByName(name) as common.IHotEditableEmbeddedComponent;
        if (!c) {
            if (finalEvalCallback)
                finalEvalCallback();
            return false;
        }
        c.refresh(urlParameters, editModeOn, finalEvalCallback);
        return true;
    }
    refreshEmbeddedComponents(urlParameters?: {}) {
        if (!this.hasEmbeddedContents()) return;
        urlParameters = urlParameters || {};
        if (!urlParameters['culture'] && context.culture && context.culture.name)
            urlParameters['culture'] = context.culture.name;
        for (let i = 0; i < (this._embeddedContentModels || []).length; i++) {
            const m = this._embeddedContentModels[i];
            if (m)
                this._innerRefreshHotEmbeddedComponent(m.elementName, urlParameters);
        }
    }
    refreshBrotherEmbeddedComponents(currentEmbeddedComponentName: string) {
        if (!this._sharedEmbeddedParentForm)
            return this;
        const f = this._sharedEmbeddedParentForm.getHotEmbeddedComponentByName(currentEmbeddedComponentName);
        if (f && f.refreshBrotherEmbeddedComponents)
            f.refreshBrotherEmbeddedComponents();
        return this;
    }
    restoreBrotherEmbeddedComponents(currentEmbeddedComponentName: string) {
        if (!this._sharedEmbeddedParentForm)
            return this;
        const f = this._sharedEmbeddedParentForm.getHotEmbeddedComponentByName(currentEmbeddedComponentName);
        if (f && f.refreshBrotherEmbeddedComponents)
            f.restoreBrotherEmbeddedComponents();
        return this;
    }
    ensureBrotherEmbeddedComponentsIsDefaultUrl(currentEmbeddedComponentName: string) {
        if (!this._sharedEmbeddedParentForm)
            return this;
        const f = this._sharedEmbeddedParentForm.getHotEmbeddedComponentByName(currentEmbeddedComponentName);
        if (f && f.refreshBrotherEmbeddedComponents)
            f.ensureBrotherEmbeddedComponentsIsDefaultUrl();
        return this;
    }
    getHotEmbeddedComponents() {
        const res = [] as common.IHotEditableEmbeddedComponent[];
        const all = this.getFields();
        for (let i = 0; i < all.length; i++) {
            const f = all[i];
            if (f.fieldType === common.HotEditableFieldTypes.embeddedForm)
                res.push(f as common.IHotEditableEmbeddedComponent);
        }
        return res;
    }
    getHotEmbeddedComponentByName(name: string) {
        const all = this.getFields();
        for (let i = 0; i < all.length; i++) {
            const f = all[i];
            if (f.fieldType === common.HotEditableFieldTypes.embeddedForm && f.elementName === name)
                return f as common.IHotEditableEmbeddedComponent;
        }
        return null;
    }
    getEmbeddedContentModelByName(elementName: string) {
        if (!elementName)
            throw "L'argument 'componentName' est obligatoire.";
        for (let i = 0; i < this._embeddedContentModels.length; i++) {
            const c = this._embeddedContentModels[i] as any as common.IEmbeddedContentModel;
            if (c.elementName === elementName)
                return c;
        }
        return null as common.IEmbeddedContentModel;
    }
    hasEditionEmbeddedForm() {
        const all = this.getHotEmbeddedComponents();
        for (let i = 0; i < all.length; i++)
            if (all[i].editModeOn)
                return true;
        return false;
    }
}
export = HotEditableFormManager;